import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from './NegativeToast';

const DeletedToast = ({ name }) => (
  <NegativeToast className="aridhia-deleted-toast">
    <FormattedMessage id="toast.deleted" values={{ name }} />
  </NegativeToast>
);

export default DeletedToast;
